import { inject } from '@angular/core'
import { CanActivateFn, RedirectCommand, Router } from '@angular/router'

import { DomainService } from '../../../shared/services/domain.service'
import { HelperService } from '../../../shared/services/helper.service'

export const demoAccountGuard: CanActivateFn = () => {
	const router = inject(Router)
	const helperService = inject(HelperService)
	const domainService = inject(DomainService)

	const demoCredential = `demo-${domainService.domain.replace('.', '')}`

	if (helperService.getUserData()?.user_fields?.NAME !== demoCredential) {
		return true
	}

	return new RedirectCommand(router.parseUrl('home'))
}
